import sat1 from "./sat-1.jpg";
import sat2 from "./sat-2.jpg";
import sat3 from "./sat-3.jpg";
import sat4 from "./sat-4.jpg";
import sat5 from "./sat-5.jpg";
import sat6 from "./sat-6.jpg";
import sat7 from "./sat-7.jpg";
import sat8 from "./sat-8.jpg";
import sat9 from "./sat-9.jpg";
import sat10 from "./sat-10.jpg";
import sat11 from "./sat-11.jpg";
import sat12 from "./sat-12.jpg";
import sat13 from "./sat-13.jpg";
import sat14 from "./sat-14.jpg";
import sat15 from "./sat-15.jpg";
import sat16 from "./sat-16.jpg";
import sat17 from "./sat-17.jpg";
import sat18 from "./sat-18.jpg";
import sat19 from "./sat-19.jpg";
import sat20 from "./sat-20.jpg";
import sat21 from "./sat-21.jpg";
import sat22 from "./sat-22.jpg";
import sat23 from "./sat-23.jpg";
import sat24 from "./sat-24.jpg";
import sat25 from "./sat-25.jpg";
import sat26 from "./sat-26.jpg";
import sat27 from "./sat-27.jpg";
import sat28 from "./sat-28.jpg";
import sat29 from "./sat-29.jpg";
import sat30 from "./sat-30.jpg";
import sat31 from "./sat-31.jpg";
import sat32 from "./sat-32.jpg";
import sat33 from "./sat-33.jpg";
import sat34 from "./sat-34.jpg";
import sat35 from "./sat-35.jpg";
import sat36 from "./sat-36.jpg";
import sat37 from "./sat-37.jpg";
import sat38 from "./sat-38.jpg";
import sat39 from "./sat-39.jpg";
import sat40 from "./sat-40.jpg";
import sat41 from "./sat-41.jpg";
import sat42 from "./sat-42.jpg";
import sat43 from "./sat-43.jpg";
import satFp1np3d from "./sat-fp-1np-3d.jpg";
import satFp1np2d from "./sat-fp-1np-2d.jpg";
import satFp2np3d from "./sat-fp-2np-3d.jpg";
import satFp2np2d from "./sat-fp-2np-2d.jpg";

export const sataliceImages = [
  sat1, sat2, sat3, sat4, sat5, sat6, sat7, sat8, sat9, sat10,
  sat11, sat12, sat13, sat14, sat15, sat16, sat17, sat18, sat19, sat20,
  sat21, sat22, sat23, sat24, sat25, sat26, sat27, sat28, sat29, sat30,
  sat31, sat32, sat33, sat34, sat35, sat36, sat37, sat38, sat39, sat40,
  sat41, sat42, sat43,
];

export const sataliceFloorPlans = [
  { image: satFp1np3d, label: "1. NP – 3D" },
  { image: satFp1np2d, label: "1. NP – 2D" },
  { image: satFp2np3d, label: "2. NP – 3D" },
  { image: satFp2np2d, label: "2. NP – 2D" },
];
